'use strict';

var unified = require('unified');
var parse = require('remark-parse');
var stringify = require('remark-stringify');

module.exports = unified().use(parse).use(stringify).freeze();



//////////////////
// WEBPACK FOOTER
// ./~/remark/index.js
// module id = 327
// module chunks = 94053359063892 107818501498521